import React from "react";
import { useState } from "react";
import CreateCardFirstStepScreen from "../CreateCardFirstStepScreen";
import CreateCardSecondStepScreen from "../CreateCardSecondStepScreen";
import { CreateCardScreenProps } from "../AuthStack";

const CreateCard = ({ navigation }: CreateCardScreenProps) => {
	const [isFirstStepDone, setIsFirstStepDone] = useState(false);
	const [studentId, setStudentId] = useState("");
	const [institution, setInstitution] = useState("");
	const [dob, setDob] = useState("");

	return (
		<>
			{!isFirstStepDone ? (
				<CreateCardFirstStepScreen
					setStudentId={setStudentId}
					setInstitution={setInstitution}
					setDob={setDob}
					setIsFirstStepDone={setIsFirstStepDone}
				/>
			) : (
				<CreateCardSecondStepScreen
					studentId={studentId}
					institution={institution}
					dob={dob}
					navigation={navigation}
				/>
			)}
		</>
	);
};

export default CreateCard;
